export default __webpack_public_path__ + "static/media/bharat_details_image.0fb31592.png";